import React from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { IBarsorting2Data, ITaskEditorProps } from "../../../../../../common/types";

import { setItem, hasItem } from "../../../../../cookie";

import ScoreEditor from "../../../../Score";

import EditorBar, {
    FlexLeft,
    FlexRight,
    Center,
} from "../../../EditorBar";

import getScore from "../../Common/getScore";
import getScale from "../../Common/getScale";
import getTempo from "../../Common/getTempo";
import ChangeColor from "../../Common/ChangeColor";
import ChangeScale from "../../Common/ChangeScale";
import ChangeTempo from "../../Common/ChangeTempo";
import useExerciseEditor from "../../Common/useExerciseEditor";
import AudioUploader from "../../Common/AudioUploader";

import messages from "./messages";

const BarSorting2Editor = ({ taskIndex, toggleInlineEditor, plan, publicView, inlineEditorOpen, reload }: ITaskEditorProps) => {
    const {
        openChanger,
        playable,
        handleChangeOpen,
        setPopupRef,
        storeScore,
        changeTempo,
        setPlayable,
        exportScore,
    } = useExerciseEditor({ plan, inlineEditorOpen, taskIndex });

    const changeScaleCallback = () => {
        if (!inlineEditorOpen) {
            reload!();
        }
    }

    const task = plan.tasks[taskIndex];
    const data = task.data as IBarsorting2Data;
    const forwardProps = {
        plan,
        taskIndex,
        openChanger,
        handleChangeOpen,
        setPopupRef,
    }
    return (
        <div>
            {inlineEditorOpen && (
                <ScoreEditor
                    taskType="barSorting2"
                    score={JSON.parse(JSON.stringify(getScore(plan, task) || {}))}
                    scale={getScale(plan, task)}
                    tempo={getTempo(plan, task)}
                    setScore={storeScore}
                    isSameLineHeight
                    changeTempo={changeTempo}
                />
            )}
            {!publicView && (
                <EditorBar>
                    <FlexLeft>
                        {data && <ChangeScale {...forwardProps} max={2.5} changeCallback={changeScaleCallback} />}
                        <AudioUploader plan={plan} taskIndex={taskIndex} />
                    </FlexLeft>
                    <Center
                        disabled={(inlineEditorOpen && !playable)}
                        tooltip={!playable && inlineEditorOpen && <FormattedMessage {...messages.createScoreTooltip} />}
                        onClick={() => {
                            toggleInlineEditor(!inlineEditorOpen);
                            setPlayable(true);
                            if (inlineEditorOpen) {
                                exportScore();
                            }
                            setItem("barSorting2Done", "1", 60 * 60 * 24 * 365, "/");
                        }}
                        className={cn(
                            !(inlineEditorOpen && !playable) &&
                            !hasItem("barSorting2Done") &&
                            !task.ref &&
                            "pulsate"
                        )}
                    >
                        {inlineEditorOpen ? (
                            <FormattedMessage {...messages.stopEdit} />
                        ) : (
                            <FormattedMessage {...messages.cropScore} />
                        )}
                    </Center>
                    <FlexRight>
                        <ChangeTempo {...forwardProps} />
                        <ChangeColor
                            {...forwardProps}
                            color={data?.color}
                        />
                    </FlexRight>
                </EditorBar>
            )}
        </div>
    );
}

export default BarSorting2Editor;
